// ##### Komarov 2025-08-05
import config from '../config';
import { SET_SEARCH_HOTELS_LINKS } from '../constants';

const formInitialState = (supportedLangs) => {
  return supportedLangs.reduce((acc, lang) => {
    acc[lang] = {};
    return acc;
  }, {});
};

const initialState = formInitialState(config.supportedLangs);

function setSearchHotelsLinks(state = initialState, action) {
  switch (action.type) {
    case SET_SEARCH_HOTELS_LINKS:
      return {
        ...state,
        ...action.payload,
      };
    default:
      return state;
  }
}

export default setSearchHotelsLinks;
